export default __webpack_public_path__ + "static/media/image.onesmartbee-private-limited.1d160079.png";